import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators, compose } from 'redux';

function mapStateToProps(state){
  //TODO: Connect Redux state to ProviderConfiguration
  return state;
}

function mapDispatchToProps(dispatch){
  //TODO: Bind Redux action creators to ProviderConfiguration
  return bindActionCreators({},dispatch);
}

export default compose(
  withRouter,
  connect(mapStateToProps,mapDispatchToProps)
);



// WEBPACK FOOTER //
// ./src/routes/ProviderConfiguration/connect.js